import React from 'react';
import { Table } from 'react-bootstrap';


export const RenderColumns: React.FunctionComponent<{
    columns: Array<string>
    customRenderColumn?(column: string, index: number): JSX.Element
}> = ({ columns, customRenderColumn }) => {
    return (
        <thead>
            <tr>
                {columns.map((item, index) => {
                    if (customRenderColumn) {
                        return customRenderColumn(item, index)
                    }
                    return (
                        <th key={index}>{item}</th>
                    )
                })}
            </tr>
        </thead>
    )
}


export interface IRowBootstrapPropss<T = unknown> {
    data: Array<T>
    renderRowItem?(item: T, index: number): JSX.Element
    generateCustomLink?(item: T): string
    onClickItem?(item: T): void
}

export const RenderRows: <T>(p: IRowBootstrapPropss<T>) => React.ReactElement = (props) => {
    return (
        <tbody>
            {props.data.map((item, index) => {
                return (
                    <tr key={index} style={{ cursor: "pointer" }} onClick={(e) => {
                        e.preventDefault()
                        if (props.onClickItem) {
                            props.onClickItem(item)
                        }

                    }}>
                        {props.generateCustomLink ? <a href={`${props.generateCustomLink(item)}`} style={{ display: "contents", color: "inherit" }}>{props.renderRowItem(item, index)}</a> :
                            props.renderRowItem(item, index)
                        }
                    </tr>
                )
            })}
        </tbody>
    )
}

export interface ITableBootstrapPropss<T = unknown> {
    columns: Array<string>
    data: Array<T>
    customRenderColumn?(column: string, index: number): JSX.Element
    renderRowItem(item: T, index: number): JSX.Element
    onClickItem?(item: T): void
    generateCustomLink?(item: T): string
}
const TableBootstrap: <T>(p: ITableBootstrapPropss<T>) => React.ReactElement = (props) => {
    // const TableBootstrap = <T extends any>(): React.FunctionComponent<ITableBootstrapPropss<T>> => (props) => {

    return (
        <Table responsive striped bordered hover className="mt-2 mb-2" >
            {<RenderColumns columns={props.columns} customRenderColumn={props.customRenderColumn} />}
            {<RenderRows<any> data={props.data} renderRowItem={props.renderRowItem} onClickItem={props.onClickItem} generateCustomLink={props.generateCustomLink} />}
        </Table>
    );
}
export default TableBootstrap;
export { TableBootstrap };